(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/race-handler/race/create-race-handler-base.js') >= 0) return;  svs.modules.push('/components/sport/race-handler/race/create-race-handler-base.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _svs$components$sport = svs.components.sport.raceHandler.race,
  createRaceModel = _svs$components$sport.createRaceModel,
  isRaceModel = _svs$components$sport.isRaceModel,
  getRaceId = _svs$components$sport.getRaceId;
const normalizeRaceModel = svs.components.sport.raceHandler.race.normalizeRaceModel;
const logger = svs.components.sport.raceHandler.logger;
const getDrawPath = drawNumber => "/racing/1/race/draw/".concat(drawNumber);
const createModelCollection = () => {
  const models = new Map();
  const addModel = raceData => {
    const raceModel = createRaceModel();
    raceModel.setData(raceData);
    if (!isRaceModel(raceModel)) {
      throw new Error('Race model must be provided');
    }
    const raceId = getRaceId(raceModel.getProductId(), raceModel.getDrawNumber());
    models.set(raceId, raceModel);
    return raceModel;
  };
  const setModel = raceModel => {
    if (!isRaceModel(raceModel)) {
      throw new Error('Race model must be provided');
    }
    models.set(raceModel.getRaceId(), raceModel);
  };
  const getCollection = () => models;
  const getModel = raceId => models.get(raceId);
  const getSerializeModel = () => {
    const racesObj = {};
    for (const _ref of models.entries()) {
      var _ref2 = _slicedToArray(_ref, 2);
      const raceId = _ref2[0];
      const race = _ref2[1];
      racesObj[raceId] = {
        model: race.getData(),
        timestamp: race.getTimestamp()
      };
    }
    return racesObj;
  };
  const clear = () => {
    models.clear();
  };
  return {
    addModel,
    setModel,
    getCollection,
    getSerializeModel,
    getModel,
    clear
  };
};
const createRaceHandlerBase = function () {
  let privateInterface = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  privateInterface.raceCache = createModelCollection();
  return function () {
    let publicInterface = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    publicInterface.fetch = async (productId, drawNumber, shouldForceFetch) => {
      var _data;
      const productPath = getDrawPath(drawNumber);
      const raceId = getRaceId(productId, drawNumber);
      let race = privateInterface.raceCache.getModel(raceId);
      if (!shouldForceFetch && race && !race.isOutdated()) {
        return race;
      }

      let data;
      try {
        data = await privateInterface.jupiter(productPath, {
          method: 'GET'
        });
      } catch (err) {
        logger.warn("Failed fetching race with drawNumber: ".concat(drawNumber, ". Error: ").concat(err));
        throw new Error("Failed fetching race with drawNumber: ".concat(drawNumber));
      }
      if ((_data = data) !== null && _data !== void 0 && _data.race) {
        const normalizedRaceModel = normalizeRaceModel({
          drawNumber,
          productId,
          data: data.race
        });
        race = privateInterface.raceCache.addModel(normalizedRaceModel);
      }
      return race;
    };
    publicInterface.get = (productId, drawNumber) => {
      const raceId = getRaceId(productId, drawNumber);
      const race = privateInterface.raceCache.getModel(raceId);
      return race;
    };
    publicInterface.getModel = () => privateInterface.raceCache.getSerializeModel();
    publicInterface.destroy = () => {
      privateInterface.raceCache.clear();
    };
    return publicInterface;
  };
};
setGlobal('svs.components.sport.raceHandler.race.createRaceHandlerBase', createRaceHandlerBase);

 })(window);